export const Paths = Object.freeze({
  INVENTORY: "/inventory",
  LIST: "/list",
  FORM: "/form",
})
